module.exports = __webpack_public_path__ + "static/media/sketching4.98c9e2de.jpg";